export default {
	DEBUG: WEBPACK_DEBUG_ENV,
	TEST: WEBPACK_TEST_ENV
}



// WEBPACK FOOTER //
// ./config.js